import React from 'react';
import { AwayGoal, HomeGoal, MatchScore } from 'app/components/match/matchDetailHeader/MatchDetailHeaderStyles';
import { Typography } from '@fupa/fupa-uikit';
import styled from 'styled-components';
const Container = styled.div.withConfig({
  componentId: "sc-1udaiq7-0"
})(["display:flex;flex-direction:column;align-items:center;justify-content:space-between;"]);
export default function MatchResult(_ref) {
  let {
    data
  } = _ref;
  if (!data) {
    return /*#__PURE__*/React.createElement("div", null);
  }
  return /*#__PURE__*/React.createElement(Container, {
    "data-sentry-element": "Container",
    "data-sentry-component": "MatchResult",
    "data-sentry-source-file": "MatchResult.tsx"
  }, /*#__PURE__*/React.createElement(MatchScore, {
    "data-sentry-element": "MatchScore",
    "data-sentry-source-file": "MatchResult.tsx"
  }, /*#__PURE__*/React.createElement(HomeGoal, {
    "data-sentry-element": "HomeGoal",
    "data-sentry-source-file": "MatchResult.tsx"
  }, /*#__PURE__*/React.createElement(Typography, {
    variant: "display2",
    "data-sentry-element": "Typography",
    "data-sentry-source-file": "MatchResult.tsx"
  }, data.homeGoals)), /*#__PURE__*/React.createElement(Typography, {
    variant: "display2",
    "data-sentry-element": "Typography",
    "data-sentry-source-file": "MatchResult.tsx"
  }, ":"), /*#__PURE__*/React.createElement(AwayGoal, {
    "data-sentry-element": "AwayGoal",
    "data-sentry-source-file": "MatchResult.tsx"
  }, /*#__PURE__*/React.createElement(Typography, {
    variant: "display2",
    "data-sentry-element": "Typography",
    "data-sentry-source-file": "MatchResult.tsx"
  }, data.awayGoals))), /*#__PURE__*/React.createElement(Typography, {
    variant: "caption1",
    "data-sentry-element": "Typography",
    "data-sentry-source-file": "MatchResult.tsx"
  }, data.minute, "'", data.additionalMinute ? "+".concat(data.additionalMinute) : ''));
}